import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'
import { editorialHorizontalTextRevealAnimation } from '@/components/sections/animations/editorial-horizontal-text'
import Spacer from '@/components/sections/spacer'

import { cn } from '@/lib/utils'

export type EditorialHorizontalTextProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    title: string
    text_1: string
    text_2: string
  }>

const EditorialHorizontalText = ({
  title,
  text_1,
  text_2,
  ...props
}: EditorialHorizontalTextProps) => {
  return (
    <Motion animation={editorialHorizontalTextRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Spacer variant="xxl" />
          <Container>
            <Grid className="gap-y-spacing-lg">
              {title ? (
                <div
                  className={cn('col-span-2 md:col-span-6', {
                    'lg:col-span-12': !text_1 && !text_2,
                    'lg:col-span-6': text_1 || text_2,
                    'lg:col-span-4': text_1 && text_2
                  })}
                >
                  <Typography variant="h3" component="h2" data-motion-title>
                    {title}
                  </Typography>
                </div>
              ) : null}

              {text_1 ? (
                <div
                  className={cn('col-span-2 md:col-span-6', {
                    'lg:col-span-12': !title && !text_2,
                    'lg:col-span-6': title || text_2,
                    'lg:col-span-4': title && text_2
                  })}
                >
                  <Typography
                    variant="regular"
                    paragraph
                    data-motion-text-1
                    className="text-regular md:text-large text-text-primary-light dark:text-text-primary-dark"
                  >
                    {text_1}
                  </Typography>
                </div>
              ) : null}

              {text_2 ? (
                <div
                  className={cn('col-span-2 md:col-span-6', {
                    'lg:col-span-12': !title && !text_1,
                    'lg:col-span-6': title || text_1,
                    'lg:col-span-4': title && text_1
                  })}
                >
                  <Typography
                    variant="regular"
                    paragraph
                    data-motion-text-2
                    className="text-regular md:text-large text-text-primary-light dark:text-text-primary-dark"
                  >
                    {text_2}
                  </Typography>
                </div>
              ) : null}
            </Grid>
          </Container>
          <Spacer variant="xxl" />
        </Section>
      )}
    </Motion>
  )
}

export default EditorialHorizontalText
